import React from 'react'
import PieChart from 'highcharts-react-official'
import Highcharts from 'highcharts/highcharts'

Highcharts.setOptions({ lang: { thousandsSep: ',' } });

const toTon = (value) => Math.round((+value || 0) / 1000)

export default function ProductionChart({ data, height }) {
    const categories = [
        'ฤดูฝน ' + (data?.RainyYear || ''),
        'ฤดูแล้ง ' + (data?.DryYear || ''),
        'รวมทั้งปี'
    ]

    const options = {
        chart: { type: 'column', height: height || 400 },
        title: { text: '' },
        subtitle: { text: 'หน่วย : ตัน', align: 'left' },
        xAxis: { categories },
        yAxis: {
            min: 0,
            title: null,
            labels: {
                formatter: function () {
                    return this.value?.toLocaleString();
                }
            },
        },
        legend: { enabled: true, verticalAlign: 'top' },
        tooltip: {
            shared: true,
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormatter: function () {
                return `${this.series.name}: <b>${this.y?.toLocaleString()}</b><br/>`
            }
        },
        plotOptions: {
            column: {
                pointPadding: 0.1,
                borderWidth: 0,
                borderRadius: 3,
                dataLabels: {
                    enabled: true,
                    style: { fontWeight: 'bolder' },
                    formatter: function () {
                        return this.y?.toLocaleString()
                    }
                }
            }
        },
        series: [
            {
                name: 'เป้าหมายการผลิต (ตัน)',
                type: 'column',
                color: '#C5E0B4',
                // รวมทั้งปีคำนวณจากค่าที่ปัดเป็นตันแล้ว เพื่อให้เท่ากับผลบวกของ 2 ฤดูเสมอ
                data: [toTon(data?.RainyTarget), toTon(data?.DryTarget), toTon(data?.RainyTarget) + toTon(data?.DryTarget)]
            },
            {
                name: 'เมล็ดดี',
                type: 'column',
                color: '#375623',
                data: [toTon(data?.RainyActual), toTon(data?.DryActual), toTon(data?.RainyActual) + toTon(data?.DryActual)]
            },
        ]
    }

    return (
        <PieChart options={options} highcharts={Highcharts} />
    )
}
